import { DEFAULT_ESTIMATED_TIME } from '../components/ui/EstimatedTimeSlider';
import { parseDailyReportItemFields } from '../components/reports/DailyReportPrintForm';

const INVOICE_STATUS_LABELS = {
  pending_price: 'قیمت‌گذاری نشده',
  priced: 'قیمت‌گذاری شده',
  approved: 'تایید شده',
  finalized: 'نهایی',
};

/** Persist one report line as JSON (backward-compatible with legacy title\\ndesc). */
export function serializeDailyReportItem(item) {
  const invoiceId = item.invoiceId ?? item.invoiceTicketId ?? null;
  return JSON.stringify({
    v: 1,
    title: item.title || '',
    description: item.description || '',
    companyName: item.companyName || '',
    phoneNumber: item.phoneNumber || '',
    fullName: item.fullName || '',
    category: item.category || 'other',
    partId: item.partId ?? null,
    invoiceId,
    invoiceStatus: item.invoiceStatus || '',
    invoiceStatusLabel: item.invoiceStatusLabel || '',
    invoiceDepartmentName: item.invoiceDepartmentName || '',
    estimatedTime: item.estimatedTime ?? DEFAULT_ESTIMATED_TIME,
  });
}

export function parseDailyReportItemContent(content) {
  const empty = {
    title: '',
    description: '',
    companyName: '',
    phoneNumber: '',
    fullName: '',
    category: 'other',
    partId: null,
    invoiceId: null,
    invoiceStatus: '',
    invoiceStatusLabel: '',
    invoiceDepartmentName: '',
    estimatedTime: DEFAULT_ESTIMATED_TIME,
  };
  if (!content) return empty;

  try {
    const parsed = JSON.parse(content);
    if (parsed && parsed.v === 1) {
      const invoiceId = parsed.invoiceId ?? parsed.invoiceTicketId ?? null;
      return {
        title: parsed.title || '',
        description: parsed.description || '',
        companyName: parsed.companyName || '',
        phoneNumber: parsed.phoneNumber || '',
        fullName: parsed.fullName || '',
        category: parsed.category || 'other',
        partId: parsed.partId ?? null,
        invoiceId,
        invoiceStatus: parsed.invoiceStatus || '',
        invoiceStatusLabel: parsed.invoiceStatusLabel || INVOICE_STATUS_LABELS[parsed.invoiceStatus] || '',
        invoiceDepartmentName: parsed.invoiceDepartmentName || '',
        estimatedTime: parsed.estimatedTime ?? DEFAULT_ESTIMATED_TIME,
      };
    }
  } catch {}

  const [title, ...rest] = content.split('\n');
  const description = rest.join('\n');
  const fields = parseDailyReportItemFields({ description, companyName: '' });
  return {
    title: title || '',
    description: fields.description === '—' ? description : fields.description,
    companyName: fields.company !== '—' ? fields.company : '',
    phoneNumber: fields.phoneNumber !== '—' ? fields.phoneNumber : '',
    fullName: fields.fullName !== '—' ? fields.fullName : '',
    category: 'other',
    partId: null,
    invoiceId: null,
    invoiceStatus: '',
    invoiceStatusLabel: '',
    invoiceDepartmentName: '',
    estimatedTime: DEFAULT_ESTIMATED_TIME,
  };
}

export function invoiceCostLabel(item) {
  const id = item.invoiceId ?? item.invoiceTicketId;
  if (!id) return '';
  const status = item.invoiceStatusLabel || INVOICE_STATUS_LABELS[item.invoiceStatus] || '';
  return status ? `فاکتور #${id} · ${status}` : `فاکتور #${id}`;
}

export function dailyReportItemToRow(item) {
  return {
    id: item.id,
    title: item.title,
    description: item.description,
    companyName: item.companyName,
    phoneNumber: item.phoneNumber,
    fullName: item.fullName,
    category: item.category,
    partId: item.partId,
    invoiceId: item.invoiceId ?? item.invoiceTicketId ?? null,
    estimatedTime: item.estimatedTime,
    cost: invoiceCostLabel(item),
  };
}

export { INVOICE_STATUS_LABELS };
